const BaseView = require("./baseview").BaseView;

/**
 * Constructs a View
 * @extends woosmap.BaseView
 * @memberOf woosmap
 */
class View extends BaseView {
    /**
     * @param {google.maps.Map} map the map to decorate
     * @param {String|Array.<DeprecatedStyleRule>|BaseViewOptions} [markersOrOptions]
     *  the marker base url or the array of style rules.
     * @param {Number} [zoomLevel] the zoom level to use when selecting a Store.
     * @constructor
     */
    constructor(map, markersOrOptions, zoomLevel) {
        super();
        if (Array.isArray(markersOrOptions) || typeof markersOrOptions === "string") {
            super.init(map, {
                markers: markersOrOptions,
                zoomLevel: zoomLevel,
            });
        } else {
            super.init(map, markersOrOptions);
        }
    }

    /**
     * Adds widget to the google map at position
     * @param widget
     * @param position
     * @deprecated
     * @private
     */
    addMapsWidget(widget, position) {
        this._map.controls[position].push(widget.getContainer());
    }

    /**
     * Sets the current store and display it.
     * @param {object}stores we use the first store from the features list.
     * @deprecated
     * @private
     */
    setAndDisplayCurrentStore(stores) {
        this._currentStore = stores.features[0];
        this.displayStore(this._currentStore);
    }
}

exports.View = View;
